import { render, staticRenderFns } from "./VKAuth.vue?vue&type=template&id=927bc796&lang=pug&"
import script from "./VKAuth.vue?vue&type=script&lang=ts&"
export * from "./VKAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports